/* eslint react/no-direct-mutation-state: "off", 'jsx-a11y/alt-text': 'off', 'no-redeclare': 'off', 'no-useless-concat': 'off', eqeqeq: 'off', no-unused-vars: 'off' */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Col, Button, FormGroup, Label, Form, Modal, Table } from 'reactstrap';
import DatePicker from 'react-datepicker';
import { Redirect } from 'react-router-dom';
import {MdSave} from 'react-icons/md';
import { FaRegCalendarAlt, FaClock} from 'react-icons/fa';
import { FaPencilAlt as Edit} from 'react-icons/fa';
import moment from 'moment';
import TimePicker from 'rc-time-picker';
import { Icon } from 'semantic-ui-react';
import { CheckBoxSelection, Inject, MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
import { GetPreventativeMaintenanceDetails, GetWorkOrderBuildingsList, SaveAttachmentToFolder, DeleteAttachment, GetWorkorderTechnician, UpdatePreventativeMaintenance, DownloadAttachment, AddPMAttachments, DeletePMAttachment, UpdatePreventativeMaintenanceState, GetBuildingPoints, GetBuildingEquipmentPoints, GetUsageFamilyTypesBySiteId, GetUsageEquipmentsByFamilyType } from '../../../../action/workorderAction';
import classnames from 'classnames';
import { IoMdClose } from 'react-icons/io';
import DeleteIcon from '../../../../Assets/images/Icons__trash2.svg';
import ProgressBar from 'react-bootstrap/ProgressBar';

const ErrorPadding = {
    color: '#D42D27',
    fontfamily: 'Lato',
    fontStyle: 'italic',
    border: '2px solid #D42D27',
    height: '40px',
    padding: '10px',
    float: 'right',
    marginRight: '25px'
};

const ErrorSign = {
    color: '#D42D27',
    paddingLeft: '8px',
    paddingTop: '0px',
    paddingRight: '14px',
    width: '22px',
    height: '22px',
    top: '406px',
    left: '959px'
};

class UpadtePreventativeMaintenance extends Component {

    componentWillMount() {
        this.props.GetWorkOrderBuildingsList();
        const l_Request = this.props.GetPreventativeMaintenanceDetails(this.props.PMId);
        l_Request.then((result) => {
            let PMDetails = this.props.getDetails.PreventativeMaintenanceDetail;
            if (PMDetails !== undefined && PMDetails !== null) {
                var HasCalendarDisplay = 'block';
                var EstimatedTimeStr = PMDetails.estimatedTime !== "" ? PMDetails.estimatedTime.split(':') : "";
                var dt = null;
                if(EstimatedTimeStr !== ""){
                    dt = moment(EstimatedTimeStr[0]+':'+EstimatedTimeStr[1],'HH:mm');
                }
                
                var myDate = new Date(PMDetails.dueDate)
                let utcOffsetMinute = moment().utcOffset();
                var fDate;
                if (utcOffsetMinute >= 0) {
                    fDate = moment(moment.parseZone(myDate).format("YYYY-MM-DD")).add(utcOffsetMinute, 'minutes')
                }
                else {
                    fDate = moment(moment.parseZone(myDate).format("YYYY-MM-DD")).subtract(utcOffsetMinute, 'minutes')
                }
                var PMScheduledDate = (PMDetails.dueDate === '1753-01-01T00:00:00' || PMDetails.dueDate === '0001-01-01T00:00:00') ? '---' : new Date(PMDetails.dueDate).toDateString();
                
                var l_SiteId = PMDetails.buildingId;
                var l_Buildings = l_SiteId > 0 ? this.props.getWorkOrderBuildings.filter(el => el.id == l_SiteId)[0] : null;
                var Building = (l_SiteId > 0 && l_Buildings != undefined) ? l_Buildings.name : "";
                var BuildingDate = (l_SiteId > 0 && l_Buildings != undefined) ? l_Buildings.buildingDate : "1753/01/01";
                var ServerDate = PMDetails.serverTime;
                var Equipment = (PMDetails.equipmentName != null && PMDetails.equipmentName != "") ? PMDetails.equipmentName : "";

                if (utcOffsetMinute >= 0) {
                    BuildingDate = moment(moment.parseZone(BuildingDate).format("YYYY-MM-DD")).add(utcOffsetMinute, 'minutes')
                    ServerDate = moment(moment.parseZone(ServerDate).format("YYYY-MM-DD")).add(utcOffsetMinute, 'minutes')
                }
                else {
                    BuildingDate =  moment(moment.parseZone(BuildingDate).format("YYYY-MM-DD")).subtract(utcOffsetMinute, 'minutes')
                    ServerDate =  moment(moment.parseZone(ServerDate).format("YYYY-MM-DD")).subtract(utcOffsetMinute, 'minutes')
                }
                
                var ScheduleText = '', lRecurrenceDueDate = '', lRepeatEvery = 0, lRepeatInterval = 1;
                ScheduleText = (PMDetails.scheduleType === 1 || PMDetails.scheduleType === 2) ?  PMDetails.scheduleText : '---';
                if(PMDetails.schedule !== null && PMDetails.scheduleType === 1){
                    HasCalendarDisplay = 'none';
                    if(PMDetails.schedule.startDate !== "0001-01-01T00:00:00"){
                        var myDate = new Date(PMDetails.schedule.startDate)
                        let utcOffsetMinute = moment().utcOffset();
                        var fDate1;
                        if (utcOffsetMinute >= 0) {
                            fDate1 = moment(moment.parseZone(myDate).format("YYYY-MM-DD")).add(utcOffsetMinute, 'minutes')
                        }
                        else {
                            fDate1 = moment(moment.parseZone(myDate).format("YYYY-MM-DD")).subtract(utcOffsetMinute, 'minutes')
                        }
                        lRecurrenceDueDate = new Date(fDate1);
                    }

                    if (ScheduleText == ''){
                        var recurdate = new Date(PMDetails.schedule.startDate);
                        var forma = (recurdate.getMonth() + 1) + "/" + recurdate.getDate() + "/" + recurdate.getFullYear();
                        ScheduleText = "Starting " + forma + ", " + "Every " + ((PMDetails.schedule.modifier != 1) ? PMDetails.schedule.modifier : "") + " " + this.props.getLabels['CreatePM.Interval.' + PMDetails.schedule.interval + '.Text'] + ((PMDetails.schedule.modifier != 1) ? "s" : "");
                    }

                    lRepeatEvery = PMDetails.schedule.modifier;
                    lRepeatInterval = PMDetails.schedule.interval !== 0 ? PMDetails.schedule.interval : 1;
                } 
               
                var TaskList = "";
                if(PMDetails.tasks !== undefined && PMDetails.tasks !== null && PMDetails.tasks.length){
                    TaskList = PMDetails.tasks.map(el => ({
                          "Description" : el.taskDescription,
                          "isChecked" : el.isChecked,
                    } 
                    ));                
                }

                var workorderSiteId = 0, lPointDts = [], lUnitName = '';
                if (PMDetails.scheduleType === 2 && this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings.length > 0 && PMDetails.schedule.buildingId > 0) {
                    var l_MappedSite = this.props.getWorkOrderBuildings.filter(x => x.siteId == PMDetails.schedule.buildingId);
                    if (l_MappedSite !== undefined && l_MappedSite.length > 0) {
                        workorderSiteId = l_MappedSite[0].id;
                    }
                    var actualSiteId = PMDetails.schedule.buildingId;
                    if(PMDetails.schedule.buildingId !== 0){ //loading Usage Family dropdown
                        const actionResponse = this.props.GetUsageFamilyTypesBySiteId(actualSiteId);
                        actionResponse.then((result) => {
                            if (this.props.getUsageFamilyTypes !== undefined && this.props.getUsageFamilyTypes !== null && this.props.getUsageFamilyTypes.length) {
                                var lFamilyText = '';
                                var l_Familys = this.props.getUsageFamilyTypes.filter(x => x.familyId == PMDetails.schedule.familyType);
                                if (l_Familys !== undefined && l_Familys.length > 0) {
                                    lFamilyText = l_Familys[0].familyName;
                                }
                                this.setState({ FamilyText: lFamilyText, UsageFamilyTypes: this.props.getUsageFamilyTypes });
                            }
                        })
                    }

                    if(PMDetails.schedule.familyType !== 7){ //loading Usage Equipment Dropdown
                        const actionResponse1 = this.props.GetUsageEquipmentsByFamilyType(actualSiteId, PMDetails.schedule.familyType);
                        actionResponse1.then((result) => {
                            if (this.props.getUsageEquipmentsByFamily !== undefined && this.props.getUsageEquipmentsByFamily !== null && this.props.getUsageEquipmentsByFamily.length) {
                                var lEquipmentText = '';
                                var l_Equips = this.props.getUsageEquipmentsByFamily.filter(x => x.objectId == PMDetails.schedule.equipmentId);
                                if (l_Equips !== undefined && l_Equips.length > 0) {
                                    lEquipmentText = l_Equips[0].objectName;
                                }
                                this.setState({ EquipmentText: lEquipmentText, UsageEquipments: this.props.getUsageEquipmentsByFamily });
                            }
                        })                        
                        if(PMDetails.schedule.equipmentId !== 0){ //loading Point Dropdown
                            const actionResponse2 = this.props.GetBuildingEquipmentPoints(actualSiteId, PMDetails.schedule.equipmentId);
                            actionResponse2.then((result) => {
                                if (this.props.getBuildingEquipmentPoints !== undefined && this.props.getBuildingEquipmentPoints !== null && this.props.getBuildingEquipmentPoints.length) {
                                    var lUnit = '', lPointText = '';
                                    var l_Equipments = this.props.getBuildingEquipmentPoints.filter(x => (x.objectId == PMDetails.schedule.objectId && x.propertyId == PMDetails.schedule.propertyId && x.arrayIndex == PMDetails.schedule.arrayIndex));
                                    if (l_Equipments !== undefined && l_Equipments.length > 0) {
                                        lUnit = l_Equipments[0].unitName;
                                        lUnitName = l_Equipments[0].unitName;
                                        lPointText = l_Equipments[0].name;
                                    }
                                    this.setState({ PointText: lPointText, UnitName: lUnit, UsageBuildingPoints: this.props.getBuildingEquipmentPoints });
                                }
                            })
                        }
                    } else { //loading Point Dropdown
                        const actionResponse3 = this.props.GetBuildingPoints(actualSiteId);
                        actionResponse3.then((result) => {
                            if (this.props.getBuildingPoints !== undefined && this.props.getBuildingPoints !== null && this.props.getBuildingPoints.length) {
                                var lUnit = '', lPointText = '';
                                    var l_Equipments = this.props.getBuildingPoints.filter(x => (x.objectId == PMDetails.schedule.objectId && x.propertyId == PMDetails.schedule.propertyId && x.arrayIndex == PMDetails.schedule.arrayIndex));
                                    if (l_Equipments !== undefined && l_Equipments.length > 0) {
                                        lUnit = l_Equipments[0].unitName;
                                        lUnitName = l_Equipments[0].unitName;
                                        lPointText = l_Equipments[0].name;
                                    }
                                this.setState({ PointText: lPointText, UnitName: lUnit, UsageBuildingPoints: this.props.getBuildingPoints });
                            }
                        })
                    }

                    lPointDts = {
                        "dimension": PMDetails.schedule.dimension,
                        "objectId": PMDetails.schedule.objectId,
                        "propertyId": PMDetails.schedule.propertyId,
                        "unitId": PMDetails.schedule.unit,
                        "arrayIndex": PMDetails.schedule.arrayIndex
                    }
                }

                var MailAddress = "", lNotifyOthers = [];
                if (this.props.getTechnicianList !== undefined && this.props.getTechnicianList !== null && this.props.getTechnicianList.length) {
                    var TechName = this.props.getTechnicianList.filter(el => el.technicianID == PMDetails.assignedTo);
                    MailAddress = (TechName[0] !== undefined && TechName[0] !== null) ? TechName[0].emailAddress : "";

                    if(PMDetails.notifyUserIDs !== undefined && PMDetails.notifyUserIDs.length){
                        PMDetails.notifyUserIDs.forEach(e => {
                            var TechMailAddress = this.props.getTechnicianList.filter(el => el.technicianID === e)[0].emailAddress;
                            if(TechMailAddress !== ''){
                                lNotifyOthers.push(e);
                            }
                         })
                    }
                }

                this.setState({
                    PMSerialNumber : PMDetails.serialNumber,
                    StatusId : PMDetails.status,
                    PMName : PMDetails.name,
                    UserID : PMDetails.assignedTo,
                    IsEmailChecked : PMDetails.isMailRequired,
                    HasEmailAddress: MailAddress !== "" ? true : false,
                    DueDate : (PMDetails.dueDate === '1753-01-01T00:00:00' || PMDetails.dueDate === '0001-01-01T00:00:00') ? null :new Date(fDate),
                    PMBuilding : Building !== "" ? Building : "---",
                    PMFamilyType : (PMDetails.familyName != '' &&  PMDetails.familyName != null && PMDetails.familyName != undefined) ? PMDetails.familyName : "---",
                    SelectedBuildingDate: BuildingDate,
                    ServerDate : ServerDate,
                    PMEquipment : Equipment !== "" ? Equipment : "---",
                    Description: PMDetails.description,
                    EstimatedTime: dt,
                    PartsTools: PMDetails.partsTools,
                    Tasks: TaskList !== "" ? TaskList : "",
                    Taskid: PMDetails.tasks.length > 0 ? (PMDetails.tasks.length) : 1,
                    Schedule: PMDetails.schedule,
                    SchduleTypeText: ScheduleText !== "" ? ScheduleText : "---",
                    SchduleTypeTextRdl: ScheduleText !== "" ? ScheduleText : "---",
                    BuildingId: l_SiteId,
                    EquipmentId: PMDetails.equipmentId,
                    LogicalBuildingId: PMDetails.logicalBuildingId,
                    ScheduleType: PMDetails.scheduleType,
                    ScheduleTypeRdl: PMDetails.scheduleType,
                    RecurrenceDueDate: lRecurrenceDueDate,
                    RepeatEvery: lRepeatEvery,
                    RepeatInterval: lRepeatInterval,
                    UsageBuildingId: workorderSiteId,
                    UsageFamilyTypeId: PMDetails.schedule.familyType,
                    UsageEquipmentId: PMDetails.schedule.equipmentId,
                    UsagePointId: PMDetails.schedule.objectId,
                    LimitValue: PMDetails.schedule.limitValue,
                    PointDetails: lPointDts,
                    UsageRemaining: PMDetails.remainingUsage,
                    PMDueDate: PMScheduledDate,
                    IsCalendarDisplay: HasCalendarDisplay,
                    PMCustomFields: PMDetails.customFields,
                    LastSavedScheduleDts: {
                        RecurrenceDueDate: lRecurrenceDueDate, 
                        RepeatEvery: lRepeatEvery, 
                        RepeatInterval: lRepeatInterval,
                        UsageBuildingId: workorderSiteId, 
                        UsageFamilyTypeId: PMDetails.schedule.familyType, 
                        UsageEquipmentId: PMDetails.schedule.equipmentId, 
                        UsagePointId: PMDetails.schedule.objectId, 
                        UnitName: lUnitName, 
                        LimitValue: PMDetails.schedule.limitValue
                    },
                    SelectedNotifyOthersIds: lNotifyOthers
                })
                if(PMDetails.status !== '0' && this.refs.status_in_Select_input != undefined)                   
                    this.refs.status_in_Select_input.style.color = '#000000';
                   
                if(PMDetails.assignedTo !== '0' && this.refs.user_in_Select_input != undefined)
                    this.refs.user_in_Select_input.style.color = '#000000';
            }
        });
    }


    constructor(props) {
        super(props);
        this.state = {
            redirectHome: false,
            open: false,
            DueDate: '',
            PMSerialNumber: '',
            PMName: '',
            StatusId: 0,
            UserID: 0,
            IsEmailChecked:false,
            HasEmailAddress: false,
            PMBuilding: '', 
            PMFamilyType: '',
            SelectedBuildingDate: '',
            serverDate: '',
            PMEquipment: '',
            Description: '',
            EstimatedTime: '',
            PartsTools: [],
            Tasks: [],
            Schedule: [],
            ScheduleText: '',
            BuildingId: 0,
            EquipmentId: 0,
            LogicalBuildingId: 0,
            ScheduleType: 0,
            Schedulemodal: false,
            RecurrenceDueDate: '',
            RepeatEvery: 0,
            RepeatInterval: 1,
            DueDateError: false,
            RepeatEveryError: false,
            IsError: false,
            displayImageError:false,
            errorImageName:null,
            errorImageText:" file type not supported",
            error: {
                status: false,
                assigneddto: false,
                name: false,
                building: false,
                equipment: false,
                schedule: false,
                description: false,
                estimate: false,
                parts: false,
                tasklist: false,
                customname: false,
                notifyOthers:false
            },
            UsageError: {
                building: false,
                Family: false,
                Equipment: false,
                Point: false,
                limit: false
            },
            UsageBuildingId: 0,
            UsageFamilyTypes: [],
            UsageFamilyTypeId: 0,
            UsageEquipments: [],
            UsageEquipmentId: 0,
            UsageBuildingPoints: [],
            UsagePointId: 0,
            PointDetails: [],
            UnitName: '',
            LimitValue: 0,
            SchduleTypeText: '',
            FamilyText: '',
            EquipmentText: '',
            PointText: '',
            ScheduleTypeRdl: 0,
            SchduleTypeTextRdl: '',
            UsageRemaining: null,
            PMDueDate: '',
            IsCalendarDisplay: 'block',
            PMCustomFields: [],
            LastSavedScheduleDts: {
                RecurrenceDueDate: '',
                RepeatEvery: 0,
                RepeatInterval: 1,
                UsageBuildingId: 0,
                UsageFamilyTypeId: 0,
                UsageEquipmentId: 0,
                UsagePointId: 0,
                UnitName: '',
                LimitValue: 0
            },
            SelectedNotifyOthersIds: [],
        }
        this.OnStatusChange = this.OnStatusChange.bind(this);
        this.OnUserChange = this.OnUserChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.AddAttachment = this.AddAttachment.bind(this);
        this.DeleteAttachment = this.DeleteAttachment.bind(this);
        this.AttachmentDownload = this.AttachmentDownload.bind(this);
        this.onPMUpdate = this.onPMUpdate.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.handleValueChange = this.handleValueChange.bind(this);
        this.OnSort = this.OnSort.bind(this);
        this.Scheduletoggle = this.Scheduletoggle.bind(this);
        this.OnSaveRecurrencePattern = this.OnSaveRecurrencePattern.bind(this);
        this.OnCancelRecurrencePattern = this.OnCancelRecurrencePattern.bind(this);
        this.handleScheduleDueChange = this.handleScheduleDueChange.bind(this);
        this.OnIntervalChange = this.OnIntervalChange.bind(this);
        this.ScheduleTypeChange = this.ScheduleTypeChange.bind(this);
        this.OnUsageBuildingChange = this.OnUsageBuildingChange.bind(this);
        this.OnUsageFamilyTypeChange = this.OnUsageFamilyTypeChange.bind(this);
        this.OnUsageEquipmentChange = this.OnUsageEquipmentChange.bind(this);
        this.OnUsagePointsChange = this.OnUsagePointsChange.bind(this);
        this.keyPressed = this.keyPressed.bind(this);
        this.emailChecked = this.emailChecked.bind(this);
        this.dropdown_fields = { text: 'value', value: 'id' };
    }

    emailChecked(event){
        this.setState({IsEmailChecked: event.target.checked});
    }

    handleValueChange = value => {
        this.setState({ EstimatedTime : value });
    };
    
    togglePMList() {
        let IsEquipment = this.props.ForEquipment !== undefined && this.props.ForEquipment !== null ? this.props.ForEquipment : false;
        if(IsEquipment)
        {
            this.props.ShowCreateButton();
            this.props.UpdateRedirection();
        }
        this.setState({ redirectHome: true });
    }

    onCancel() {
        let IsEquipment = this.props.ForEquipment !== undefined && this.props.ForEquipment !== null ? this.props.ForEquipment : false;
        if(IsEquipment)
        {
            this.props.ShowCreateButton();
            this.props.UpdateRedirection();
        }

        this.setState({ redirectHome: true });
    }

    UpdatePMName(evt) {
        this.setState({ PMName: evt.target.value });
        var RegexRestrictSpecialCharacter =/^[a-zA-Z0-9_\-.,&()$:! ]*$/.test(evt.target.value);
    (!RegexRestrictSpecialCharacter) ? this.state.error.name = true : this.state.error.name = false;
    }

    updateDescriptionValue(evt) {
        this.setState({ Description: evt.target.value });
    }

    updatePartsTools(evt){
        this.setState({ PartsTools: evt.target.value });
    }

    updateTasks(evt){
        this.setState({ Tasks: evt.target.value });
    }

    keyPressed(event){
        var code = event.keyCode || event.which;
        if (code === 13){
            let value = event.target.value;
            let i = this.state.Taskid;
            if(value !== ''){
                //dynamically creating checkboxes
                var checkbox = document.createElement('input');
                checkbox.setAttribute('type', 'checkbox');
                checkbox.setAttribute('id','check'+i);
                checkbox.style.verticalAlign = "middle";
                console.log(checkbox);

                //dynamically creating input 
                var input = document.createElement('input');
                input.setAttribute('type','text');
                input.setAttribute('id','task'+ i);
                input.style.backgroundColor = "rgb(244,244,244)";
                input.style.border = "none";
                input.style.verticalAlign = "middle";
                input.style.width = "95%";
                input.className = "text_field_css";
                input.setAttribute('autofocus','true');
                input.addEventListener('keyup', this.keyPressed);
             
                //dynamically creating span
                var span = document.createElement('span');
                span.setAttribute('contenteditable','false');
                span.appendChild(checkbox);

                //dynamically creating td,tr
                var td = document.createElement('td');
                td.className = "col-sm-12";
                td.style.padding = "0px";
                td.appendChild(span);
                td.appendChild( document.createTextNode( '\u00A0' ) );
                td.appendChild(input);

                var tr = document.createElement('tr');
                tr.appendChild(td);

                document.getElementById("taskid").appendChild(tr);
                document.getElementById('task'+ i).focus();
                i++;
                this.setState({Taskid : i});
            }
        }
        if(event.keyCode == 8 && event.target.value == ""&& event.target.nodeName == "INPUT"){
            var id = event.target.id;
            var num = id.split("task")[1];
            if(document.getElementById("taskid").childNodes.length > 1 ){
                var parentnode = document.getElementById('check'+ num).parentNode;
                var grandparentnode = parentnode.parentNode;
                var greatgrandparentnode = grandparentnode.parentNode;
                var previouselement = greatgrandparentnode.previousSibling;
                parentnode.removeChild(document.getElementById('check'+ num));
                grandparentnode.removeChild(parentnode);
                grandparentnode.removeChild(document.getElementById('task'+num));
                greatgrandparentnode.removeChild(grandparentnode);
                document.getElementById("taskid").removeChild(greatgrandparentnode);
                previouselement.childNodes[0].childNodes[2].focus();
            }
        }
    }

    OnStatusChange() {
        var selectedOption = this.refs.status_in_Select_input.options.selectedIndex;
        var SelectedStatusId = this.refs.status_in_Select_input.options[selectedOption].id;
        this.setState({
            StatusId: SelectedStatusId
        });
        if(SelectedStatusId !== '0')
            this.refs.status_in_Select_input.style.color = '#000000';
        else
            this.refs.status_in_Select_input.style.color = '#999999';
    }

    OnUserChange() {
        var selectedOption = this.refs.user_in_Select_input.options.selectedIndex;
        var selectedUserId = this.refs.user_in_Select_input.options[selectedOption].id;
        var MailAddress = "", IsMailChecked = false;
        if(selectedUserId !== '0' && this.props.getTechnicianList !== undefined && this.props.getTechnicianList.length){
            MailAddress = this.props.getTechnicianList.filter(x => x.technicianID == selectedUserId)[0].emailAddress;
            IsMailChecked = MailAddress !== "" ? true : false;
        }
            
        this.setState({
            UserID: selectedUserId, IsEmailChecked: IsMailChecked, HasEmailAddress: IsMailChecked,   SelectedNotifyOthersIds: selectedUserId !== '0' ? this.state.SelectedNotifyOthersIds.filter(e => e !== Number(selectedUserId)) : this.state.SelectedNotifyOthersIds,
        });
        if(selectedUserId !== '0')
            this.refs.user_in_Select_input.style.color = '#000000';
        else
            this.refs.user_in_Select_input.style.color = '#999999';
    }

    onNotifyOthersSelect(args){
        var l_SelectedNotifyOthersIds = (this.state.SelectedNotifyOthersIds !== undefined && this.state.SelectedNotifyOthersIds.length) ? this.state.SelectedNotifyOthersIds : [];
        l_SelectedNotifyOthersIds.push(args.itemData.id);
        this.setState({SelectedNotifyOthersIds:  l_SelectedNotifyOthersIds})
    }

    onNotifyOthersRemove(args){
        var l_SelectedNotifyOthersIds = this.state.SelectedNotifyOthersIds;
        var FilteredData = l_SelectedNotifyOthersIds.filter(x => x !== args.itemData.id);
        this.setState({SelectedNotifyOthersIds: FilteredData });
    }

    handleChange(date) {

        var myDate = new Date(date);
        var fDate;
        let utcOffsetMinute = moment().utcOffset();
        
        if (utcOffsetMinute >= 0) {
            fDate = moment(moment.parseZone(myDate).format("YYYY-MM-DD")).add(utcOffsetMinute, 'minutes')
        }
        else {
            fDate = moment(moment.parseZone(myDate).format("YYYY-MM-DD")).subtract(utcOffsetMinute, 'minutes')
        }

        this.setState({DueDate:new Date(fDate)})
    }

    OnSort(values) {
        const sorted_data = values.sort((a, b) => {
            let nameA, nameB;
            nameA = a.orderId;
            nameB = b.orderId;
            return (nameA - nameB);
        });
        return sorted_data;
    }

    AddAttachment(e) {
        e.preventDefault();

        this.setState({
            displayImageError:false,
            errorImageName:null,
            errorImageText:" file size limit exceeded.",
        });
        var fileTypes = ['doc','docx','jpg','jpeg','png','pdf'];

        if (e.target.files && e.target.files[0]) {
            var extension = e.target.files[0].name.split('.').pop().toLowerCase(), //file extension from input file
            fileTypeSuccess = fileTypes.indexOf(extension) > -1;  //is extension in acceptable types
            var fileSize = document.getElementById('myfile').files[0].size; //Checking for file size

            if (fileTypeSuccess && fileSize <= 25000000 ) {
                let reader = new FileReader();
                let file = e.target.files[0];
                reader.onloadend = () => {
                    const data = new FormData();
                    data.append('file', file);
                    const l_Request = this.props.SaveAttachmentToFolder(data, 0);
                    l_Request.then((result) => {
                        if (this.props.getUniqueAttachmentName !== undefined && this.props.getUniqueAttachmentName !== null && this.props.getUniqueAttachmentName !== []) {
                            var lineitem = {
                                "Id": 0, "Name":file.name, "FileName":this.props.getUniqueAttachmentName.FileName
                            }
                            this.props.AddPMAttachments(lineitem, this.props.PMId);
                        }
                    });
                }
                reader.readAsDataURL(file);
            }else if(fileSize >= 25000000) { 
                this.setState({
                    displayImageError:true,
                    errorImageName:e.target.files[0].name,
                    errorImageText:" file size limit exceeded.",
                })
            }
            else  { 
                this.setState({
                    displayImageError:true,
                    errorImageName:e.target.files[0].name,
                    errorImageText:" file type not supported.",
                });
            }
        }
    }

    DeleteAttachment(id, name) {
        let lineitem = {
            "AttachmentId": id,
            "FileName": name,
        }
        let deletePromise = new Promise((resolve) => {
            this.props.DeletePMAttachment(this.props.PMId, id);
            resolve();
        });
        deletePromise.then(() => {
            this.props.DeleteAttachment(lineitem);
            this.forceUpdate();
        });
    }

    AttachmentDownload(fileName){
        this.props.DownloadAttachment(fileName);
    }

    setOpen = ({ open }) => {       
        this.setState({ open: true });      
    };

    setClose = ({ open }) => {
        this.setState({ open: false });    
    };  

    Scheduletoggle(){
        this.setState({ Schedulemodal: !this.state.Schedulemodal,
            ScheduleTypeRdl: this.state.ScheduleType, 
            SchduleTypeText: this.state.SchduleTypeTextRdl, 
            DueDateError: false, 
            RepeatEveryError: false, 
            UsageError:{
               building: false,
               Family: false,
               Equipment: false,
               Point: false,
               limit: false
            }   
        });
    }

    OnCancelRecurrencePattern(){
        this.setState({ Schedulemodal: false,
            ScheduleTypeRdl: this.state.ScheduleType, 
            SchduleTypeText: this.state.SchduleTypeTextRdl,
            DueDateError: false, 
            RepeatEveryError: false, 
            UsageError:{
               building: false,
               Family: false,
               Equipment: false,
               Point: false,
               limit: false
            },
            RecurrenceDueDate: this.state.LastSavedScheduleDts.RecurrenceDueDate,
            RepeatEvery: this.state.LastSavedScheduleDts.RepeatEvery,
            RepeatInterval: this.state.LastSavedScheduleDts.RepeatInterval, 
            UsageBuildingId: this.state.LastSavedScheduleDts.UsageBuildingId,
            UsageFamilyTypeId: this.state.LastSavedScheduleDts.UsageFamilyTypeId,
            UsageEquipmentId: this.state.LastSavedScheduleDts.UsageEquipmentId,
            UsagePointId: this.state.LastSavedScheduleDts.UsagePointId,
            UnitName: this.state.LastSavedScheduleDts.UnitName,
            LimitValue: this.state.LastSavedScheduleDts.LimitValue
        });
    }

    OnSaveRecurrencePattern(){ 
        this.setState({ DueDateError: false, RepeatEveryError: false });
        var Expression = new RegExp('^[0-9]*$');
        if(this.refs.rdl_Calendar.checked){
            var RepeatValue = this.refs.modifier_in_input.value;
            if (this.state.RecurrenceDueDate === "") {
                this.setState({ DueDateError: true });
            }
            else if (RepeatValue === "" || RepeatValue === "0" || !Expression.test(RepeatValue)) {
                this.setState({ RepeatEveryError: true });
            }
            else {
                var recurdate = new Date(this.state.RecurrenceDueDate);
                var forma = (recurdate.getMonth() + 1) + "/" + recurdate.getDate() + "/" + recurdate.getFullYear();
                var lScheduleText = "Starting " + forma + ", " + "Repeat every " + ((RepeatValue != "1") ? RepeatValue : "") + " " + this.props.getLabels['CreatePM.Interval.' + this.state.RepeatInterval + '.Text'] + ((RepeatValue != "1") ? "s" : "");
                this.setState({ RepeatEvery: RepeatValue, Schedulemodal: false, ScheduleType: 1, SchduleTypeTextRdl: lScheduleText, SchduleTypeText: lScheduleText,
                    LastSavedScheduleDts: {
                        RecurrenceDueDate: this.state.RecurrenceDueDate,
                        RepeatEvery: RepeatValue,
                        RepeatInterval: this.state.RepeatInterval,
                        UsageBuildingId: 0, UsageFamilyTypeId: 0, UsageEquipmentId: 0, UsagePointId: 0, UnitName: '', LimitValue: 0
                    }
                });
            }
        }else{
            var UsageLimitValue = this.refs.usage_parameter_in_input.value;
            this.state.UsageError.building = this.state.UsageBuildingId == '0' ? true : false;
            this.state.UsageError.Family = this.state.UsageFamilyTypeId == '0' ? true : false;
            this.state.UsageError.Equipment = (this.state.UsageEquipmentId == '0' && this.state.UsageFamilyTypeId != '7') ? true : false;
            this.state.UsageError.Point = this.state.UsagePointId == '0' ? true : false;
            this.state.UsageError.limit = (UsageLimitValue === "" || UsageLimitValue == '0' || Number.isNaN(Number(UsageLimitValue))) ? true : false;
            
            if(!this.state.UsageError.building && !this.state.UsageError.Family && !this.state.UsageError.Equipment && !this.state.UsageError.Point && !this.state.UsageError.limit)
            {
                var SCheduleText = "";
                if(this.state.UsageFamilyTypeId === '7')
                    SCheduleText =  this.state.FamilyText + ', ' + this.state.PointText + ', Interval: ' + this.state.LimitValue + ' ' + this.state.UnitName;
                else
                    SCheduleText =  this.state.FamilyText + ', ' + this.state.EquipmentText + ', ' + this.state.PointText + ', Interval: ' + this.state.LimitValue + ' ' + this.state.UnitName;
                this.setState({ LimitValue: UsageLimitValue, Schedulemodal: false, ScheduleType: 2, SchduleTypeTextRdl: SCheduleText, SchduleTypeText: SCheduleText,
                    LastSavedScheduleDts: {
                        RecurrenceDueDate: '', RepeatEvery: 0, RepeatInterval: 0,
                        UsageBuildingId: this.state.UsageBuildingId, 
                        UsageFamilyTypeId: this.state.UsageFamilyTypeId, 
                        UsageEquipmentId: this.state.UsageEquipmentId, 
                        UsagePointId: this.state.UsagePointId, 
                        UnitName: this.state.UnitName, 
                        LimitValue: UsageLimitValue
                    }
                });
            }
        }
    }

    handleScheduleDueChange(date) {
        var recurdate = new Date(date);
        var forma = (recurdate.getMonth() + 1) + "/" + recurdate.getDate() + "/" + recurdate.getFullYear();
        var lScheduleText = "Starting " + forma + ", " + "Repeat every " + ((this.state.RepeatEvery != "1") ? this.state.RepeatEvery : "") + " " + this.props.getLabels['CreatePM.Interval.' + this.state.RepeatInterval + '.Text'] + ((this.state.RepeatEvery != "1") ? "s" : "");
        this.setState({RecurrenceDueDate: date, SchduleTypeText: lScheduleText})
    }

    OnIntervalChange(){
        var selectedOption = this.refs.interval_in_Select_input.options.selectedIndex;
        var SelectedInterval = this.refs.interval_in_Select_input.options[selectedOption].id;
        var recurdate = new Date(this.state.RecurrenceDueDate);
        var forma = (recurdate.getMonth() + 1) + "/" + recurdate.getDate() + "/" + recurdate.getFullYear();
        var lScheduleText = "Starting " + forma + ", " + "Repeat every " + ((this.state.RepeatEvery != "1") ? this.state.RepeatEvery : "") + " " + this.props.getLabels['CreatePM.Interval.' + SelectedInterval + '.Text'] + ((this.state.RepeatEvery != "1") ? "s" : "");
        this.setState({
            RepeatInterval: SelectedInterval, SchduleTypeText: lScheduleText
        });
    }

    OnCalendarLimitChange(evt) {
        var recurdate = new Date(this.state.RecurrenceDueDate);
        var forma =  (recurdate.getMonth() + 1) + "/" + recurdate.getDate() + "/" + recurdate.getFullYear();
        var PMScheduleText = "Starting " + forma + ", " + "Repeat every " +  ((evt.target.value != "1") ? evt.target.value : "") + " " + this.props.getLabels['CreatePM.Interval.' + this.state.RepeatInterval + '.Text'] + ((evt.target.value != "1") ? "s" : "");
        
        this.setState({ RepeatEvery: evt.target.value, SchduleTypeText: PMScheduleText });
    }

    ClearCustomErrors(){
        this.state.error.customname = false;
        var lCustomColtxts = document.getElementsByClassName("customfieldsColtxt");
        if(lCustomColtxts !== undefined && lCustomColtxts !== null && lCustomColtxts.length){
            for(var i=0; i<lCustomColtxts.length; i++){
                var lChildrens = lCustomColtxts[i].childNodes;
                lChildrens[0].classList.remove('errortext');
                lChildrens[2].style.width = "300px";
                lChildrens[2].classList.remove('errorhighlight');
                lChildrens[3].setAttribute('hidden',true);
            }
        }
        var lCustomColddls = document.getElementsByClassName("customfieldsColddl");
        if(lCustomColddls !== undefined && lCustomColddls !== null && lCustomColddls.length){
            for(var i=0; i<lCustomColddls.length; i++){
                var lChildrens = lCustomColddls[i].childNodes;
                lChildrens[0].classList.remove('errortext');
                lChildrens[2].classList.remove('errorhighlight');
                lChildrens[3].setAttribute('hidden',true);
            }
        }
    }

    onPMUpdate() {
        this.ClearCustomErrors();
        let PMDetails = this.props.getDetails.PreventativeMaintenanceDetail; //eslint-disable-line
        let label = this.props.getLabels;
        let PMPreferences = this.props.getPreferences;
        var Status = '', AssignedTo = '', Name = '', Building = '', Equipment = '', Schedule = '', Description = '', EstimateTime = '', PartsAndTools = '', TaskList = '',NotifyOthers = '';  //eslint-disable-line
        if (PMPreferences != undefined && PMPreferences != '') {
            Status = PMPreferences.filter(x => x.field === "Status")[0];
            AssignedTo = PMPreferences.filter(x => x.field === "Assigned To")[0];
            Name = PMPreferences.filter(x => x.field === "Name")[0];
            Building = PMPreferences.filter(x => x.field === "Building")[0];
            Equipment = PMPreferences.filter(x => x.field === "Equipment")[0];
            Schedule = PMPreferences.filter(x => x.field === "Schedule")[0];
            Description = PMPreferences.filter(x => x.field === "Description")[0];
            EstimateTime = PMPreferences.filter(x => x.field === "Estimated Time")[0];
            PartsAndTools = PMPreferences.filter(x => x.field === "Parts & Tools")[0];
            TaskList = PMPreferences.filter(x => x.field === "Task List")[0];
            NotifyOthers = PMPreferences.filter(x => x.field === "Notify Others")[0];
        }

        var Tasks = [];
        if(this.refs.tasklist.childNodes.length > 0){
            let j=0, data=[], ischecked=[];
            let length = document.getElementById('taskid').childNodes.length;
            for(j=0;j<length;j++){
                data.push(document.getElementById('taskid').childNodes[j].childNodes[0].childNodes[2].value);
                ischecked.push(document.getElementById('taskid').childNodes[j].childNodes[0].childNodes[0].childNodes[0].checked);
            }
            for(j=0;j<length;j++){
                if(data[j] !== ""){
                    var TaskItem = {
                        "TaskDescription" : data[j],
                        "IsChecked" : ischecked[j]
                    }
                    Tasks.push(TaskItem);
                }
            }
        }

        (!Status.required || (Status.required && this.state.StatusId > 0)) ? this.state.error.status = false : this.state.error.status = true;
        (!AssignedTo.required || (AssignedTo.required &&  parseInt(this.state.UserID) > 0)) ? this.state.error.assigneddto = false : this.state.error.assigneddto = true;
        (!Name.required || (Name.required &&  this.refs.name_in_input.value != undefined && this.refs.name_in_input.value.trim() != "")) ? this.state.error.name = false : this.state.error.name = true;
        (!Schedule.required || (Schedule.required && this.state.ScheduleType != '0')) ? this.state.error.schedule = false : this.state.error.schedule = true;
        (!Description.required || (Description.required && this.refs.description_in_textarea.value != undefined && this.refs.description_in_textarea.value.trim() != '')) ? this.state.error.description = false : this.state.error.description = true;
        (!EstimateTime.required || (EstimateTime.required && this.refs.Time_in_timepicker.picker.value != "")) ? this.state.error.estimate = false : this.state.error.estimate = true;
        (!PartsAndTools.required || (PartsAndTools.required && this.refs.parts_in_input.value != "")) ? this.state.error.parts = false : this.state.error.parts = true;
        (!TaskList.required || (TaskList.required && Tasks.length > 0)) ? this.state.error.tasklist = false : this.state.error.tasklist = true;
        (!NotifyOthers.required || (NotifyOthers.required && this.state.SelectedNotifyOthersIds.length > 0)) ? this.state.error.notifyOthers = false : this.state.error.notifyOthers = true;
        
        var recurdate = '1753/01/01';
        if(this.state.RecurrenceDueDate != null && this.state.RecurrenceDueDate != ""){
           var validdate = new Date(this.state.RecurrenceDueDate);
           recurdate = (validdate.getMonth() + 1) + "/" + validdate.getDate() + "/" + validdate.getFullYear();
        }

        var lScheduleData = [];
        if(this.state.ScheduleType === 1){
            lScheduleData = {
                "StartDate": recurdate,
                "Modifier": this.state.RepeatEvery,
                "Interval": this.state.RepeatInterval
            }
        }
        else if(this.state.ScheduleType === 2){
            lScheduleData = {
                "StartDate": new Date(),
                "ObjectId": this.state.PointDetails.objectId,
                "PropertyId": this.state.PointDetails.propertyId,
                "LimitValue": this.state.LimitValue,
                "Dimension": this.state.PointDetails.dimension,
                "Unit": this.state.PointDetails.unitId,
                "EquipmentId": this.state.UsageEquipmentId,
                "ArrayIndex": this.state.PointDetails.arrayIndex
            }
        }else{
            lScheduleData = {
                "StartDate": new Date(),
                "Modifier": 0,
                "Interval": 0
            }
        }
        
        //custom fields validations
        var lCustomFieldCol = [];
        var lCustomColtxts = document.getElementsByClassName("customfieldsColtxt");
        if(lCustomColtxts !== undefined && lCustomColtxts !== null && lCustomColtxts.length){
            for(var i=0; i<lCustomColtxts.length; i++){
                var lChildrens = lCustomColtxts[i].childNodes;
                var CustomTxtBoxValue = lChildrens[2].value;
                CustomTxtBoxValue = CustomTxtBoxValue.trim();
                var CustomTxtBoxAttr = lChildrens[2].getAttribute("data-key");
                if(CustomTxtBoxAttr.split('~')[1] === "true" && !!CustomTxtBoxValue === false){
                    lChildrens[0].classList.add('errortext');
                    lChildrens[2].style.width = "280px";
                    lChildrens[2].classList.add('errorhighlight');
                    lChildrens[3].removeAttribute('hidden');
                    this.state.error.customname = true;
                }
                lCustomFieldCol.push({
                    "CustomFieldID" : Number(CustomTxtBoxAttr.split('~')[0]),
                    "CustomFieldValueID" : 0,
                    "CustomFieldTextValue" : CustomTxtBoxValue
                });
            }
        }
        var lCustomColddls = document.getElementsByClassName("customfieldsColddl");
        if(lCustomColddls !== undefined && lCustomColddls !== null && lCustomColddls.length){
            for(var i=0; i<lCustomColddls.length; i++){
                var lChildrens = lCustomColddls[i].childNodes;
                var CustomddlIndex = lChildrens[2].options.selectedIndex;
                var CustomddlValue = lChildrens[2].options[CustomddlIndex].id;
                var CustomddlAttr = lChildrens[2].getAttribute("data-key");
                if(CustomddlAttr.split('~')[1] === "true" && CustomddlValue === "0"){
                    lChildrens[0].classList.add('errortext');
                    lChildrens[2].classList.add('errorhighlight');
                    lChildrens[3].removeAttribute('hidden');
                    this.state.error.customname = true;
                }
                lCustomFieldCol.push({
                    "CustomFieldID" : Number(CustomddlAttr.split('~')[0]),
                    "CustomFieldValueID" : Number(CustomddlValue),
                    "CustomFieldTextValue" : ""
                });
            }
        }

        (!TaskList.required || (TaskList.required && Tasks.length > 0)) ? this.state.error.tasklist = false : this.state.error.tasklist = true;
        
        if(!this.state.error.status && !this.state.error.assigneddto && !this.state.error.name && !this.state.error.estimate
            && !this.state.error.description && !this.state.error.parts && !this.state.error.tasklist && !this.state.error.schedule && !this.state.error.customname && !this.state.error.notifyOthers)
        {
        let IsEquipment = this.props.ForEquipment !== undefined && this.props.ForEquipment !== null ? this.props.ForEquipment : false;
        let EquipmentSummaryId;
        if(IsEquipment === true && this.props.EquipmentSummary[0].EquipmentID > 0)
            EquipmentSummaryId = this.props.EquipmentSummary[0].EquipmentID;
        else if(IsEquipment === true && this.props.EquipmentSummary !== undefined )
            EquipmentSummaryId = window.top.location.href.split("EquipmentId=")[1].split("&")[0];

        var IsChecked_email = this.state.IsEmailChecked;
        if(this.refs.ref_Assigned_User != undefined || this.refs.ref_Assigned_User != null)
            IsChecked_email = this.refs.ref_Assigned_User.checked;
         
        let lineitem = {
            "Status": parseInt(this.state.StatusId),
            "Name":this.refs.name_in_input != undefined ? this.refs.name_in_input.value : "",
            "AssignedTo": parseInt(this.state.UserID),
            "IsMailRequired" : IsChecked_email,
            "Description":this.refs.description_in_textarea != undefined ? this.refs.description_in_textarea.value : "",
            "EstimatedTime": this.refs.Time_in_timepicker != undefined ? (this.refs.Time_in_timepicker.picker.value !== "" ? this.refs.Time_in_timepicker.picker.value : '00:00') : '00:00',
            "PartsTools":this.refs.parts_in_input != undefined ? this.refs.parts_in_input.value : "",
            "Tasks": Tasks,
            "DueDate": (this.state.DueDate != null && this.state.DueDate != "") ? this.state.DueDate :'1753/01/01',
            "ScheduleType": this.state.ScheduleType,
            "Schedule": lScheduleData,
            //"ScheduleText": this.state.SchduleTypeText,
            "EquipmentSummaryID" : (IsEquipment === true) ? EquipmentSummaryId : 0,
            "CustomFields": lCustomFieldCol,
            "CreatedByDate": new Date(),
            "BuildingName": this.state.PMBuilding,
            "EquipmentName": this.state.PMEquipment,
            "ScheduleText": this.state.SchduleTypeText,
            "NotifyUserIDs": this.state.SelectedNotifyOthersIds
        }        
        const l_Request = this.props.UpdatePreventativeMaintenance(lineitem, this.props.PMId);
        l_Request.then((result) => {
            if(parseInt(this.state.StatusId) === 6)
                this.props.UpdatePreventativeMaintenanceState(lineitem, this.props.PMId);
            this.setState({ redirectHome: true, IsError: false });
        });
        if(IsEquipment)
        {
            this.props.ShowCreateButton();
            this.props.UpdateRedirection();
        }
    }
    else
    {
        this.setState({ IsError: true });
    }
    }

    ScheduleTypeChange(){
        this.setState({ ScheduleTypeRdl: this.refs.rdl_Calendar.checked ? 1 : 2,
            SchduleTypeText: '', 
            DueDateError: false, 
            RepeatEveryError: false, 
            UsageError:{
                building: false,
                Family: false,
                Equipment: false,
                Point: false,
                limit: false
            } 
        });               
    }

    OnUsageBuildingChange(){
        this.setState({
            UsageFamilyTypes: [], UsageEquipments: [], UsageBuildingPoints: [],
            UsageFamilyTypeId: 0, UsageEquipmentId: 0, UsagePointId: 0
        });
        var selectedOption = this.refs.usage_building_in_Select_input.options.selectedIndex;
        var selectedBuildingId = this.refs.usage_building_in_Select_input.options[selectedOption].id;
        
        if(selectedBuildingId !== '0'){
            var actualSiteId = 0;
            if (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings.length > 0 && selectedBuildingId > 0) {
                var l_MappedSite = this.props.getWorkOrderBuildings.filter(x => x.id == selectedBuildingId);
                if (l_MappedSite !== undefined && l_MappedSite.length > 0) {
                    actualSiteId = l_MappedSite[0].siteId;
                }
            }
            const actionResponse = this.props.GetUsageFamilyTypesBySiteId(actualSiteId);
            actionResponse.then((result) => {
                if (this.props.getUsageFamilyTypes !== undefined && this.props.getUsageFamilyTypes !== null && this.props.getUsageFamilyTypes.length) {
                    this.setState({ UsageFamilyTypes: this.props.getUsageFamilyTypes });
                }
            })
        }

        this.setState({ UsageBuildingId: selectedBuildingId });
    }

    OnUsageFamilyTypeChange(){
        this.setState({UsageEquipments: [], UsageBuildingPoints: [], UsageEquipmentId: 0, UsagePointId: 0});
        var selectedOption = this.refs.usage_family_in_Select_input.options.selectedIndex;
        var selectedFamilyId = this.refs.usage_family_in_Select_input.options[selectedOption].id;

        if(selectedFamilyId !== '0'){
            var actualSiteId = 0;
            if (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings.length > 0 && this.state.UsageBuildingId > 0) {
                var l_MappedSite = this.props.getWorkOrderBuildings.filter(x => x.id == this.state.UsageBuildingId);
                if (l_MappedSite !== undefined && l_MappedSite.length > 0) {
                    actualSiteId = l_MappedSite[0].siteId;
                }
            }
        
            if (selectedFamilyId !== '7') {
                const actionResponse = this.props.GetUsageEquipmentsByFamilyType(actualSiteId, selectedFamilyId);
                actionResponse.then((result) => {
                    if (this.props.getUsageEquipmentsByFamily !== undefined && this.props.getUsageEquipmentsByFamily !== null && this.props.getUsageEquipmentsByFamily.length) {
                        this.setState({ UsageEquipments: this.props.getUsageEquipmentsByFamily });
                    }
                })
            } else {
                const actionResponse = this.props.GetBuildingPoints(actualSiteId);
                actionResponse.then((result) => {
                    if (this.props.getBuildingPoints !== undefined && this.props.getBuildingPoints !== null && this.props.getBuildingPoints.length) {
                        this.setState({ UsageBuildingPoints: this.props.getBuildingPoints });
                    }
                })
            }
        }
        var FamilyTextValue = this.refs.usage_family_in_Select_input.options[selectedOption].value;
        var SCheduleText = "";
        if(selectedFamilyId === '7')
            SCheduleText = FamilyTextValue + ', ' + this.state.PointText + ', Interval: ' + this.state.LimitValue + ' ' + this.state.UnitName;
        else
            SCheduleText = FamilyTextValue + ', ' + this.state.EquipmentText + ', ' + this.state.PointText + ', Interval: ' + this.state.LimitValue + ' ' + this.state.UnitName;
        this.setState({ UsageFamilyTypeId: selectedFamilyId, FamilyText: FamilyTextValue, SchduleTypeText: SCheduleText });
    }

    OnUsageEquipmentChange(){
        this.setState({UsageBuildingPoints: [], UsagePointId: 0});
        var selectedOption = this.refs.usage_equipment_in_Select_input.options.selectedIndex;
        var selectedEquipmentId = this.refs.usage_equipment_in_Select_input.options[selectedOption].id;
        
        if(selectedEquipmentId != '0'){
            var actualSiteId = 0;
            if (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings.length > 0 && this.state.UsageBuildingId > 0) {
                var l_MappedSite = this.props.getWorkOrderBuildings.filter(x => x.id == this.state.UsageBuildingId);
                if (l_MappedSite !== undefined && l_MappedSite.length > 0) {
                    actualSiteId = l_MappedSite[0].siteId;
                }
            }
            const actionResponse = this.props.GetBuildingEquipmentPoints(actualSiteId, selectedEquipmentId);
            actionResponse.then((result) => {
                if (this.props.getBuildingEquipmentPoints !== undefined && this.props.getBuildingEquipmentPoints !== null && this.props.getBuildingEquipmentPoints.length) {
                    this.setState({ UsageBuildingPoints: this.props.getBuildingEquipmentPoints });
                }
            })
        }
        var lEquipmentText = this.refs.usage_equipment_in_Select_input.options[selectedOption].value;
        var SCheduleText = "";
        if(this.state.UsageFamilyTypeId === '7')
            SCheduleText = this.state.FamilyText + ', ' + this.state.PointText + ', Interval: ' + this.state.LimitValue + ' ' + this.state.UnitName;
        else
            SCheduleText = this.state.FamilyText + ', ' + lEquipmentText + ', ' + this.state.PointText + ', Interval: ' + this.state.LimitValue + ' ' + this.state.UnitName;
        this.setState({UsageEquipmentId:selectedEquipmentId, EquipmentText: lEquipmentText, SchduleTypeText: SCheduleText});
    }

    OnUsagePointsChange(){
        this.setState({ UsagePointId : 0, PointDetails: [], UnitName: '' });
        var selectedOption = this.refs.usage_points_in_Select_input.options.selectedIndex;
        var selectedPointId = this.refs.usage_points_in_Select_input.options[selectedOption].id;
        var lPointDts = {
            "dimension": this.refs.usage_points_in_Select_input.options[selectedOption].getAttribute('dimension'),
            "objectId": this.refs.usage_points_in_Select_input.options[selectedOption].getAttribute('objectId'),
            "propertyId": this.refs.usage_points_in_Select_input.options[selectedOption].getAttribute('propertyid'),
            "unitId": this.refs.usage_points_in_Select_input.options[selectedOption].getAttribute('unitid'),
            "arrayIndex": this.refs.usage_points_in_Select_input.options[selectedOption].getAttribute('arrayindex')
        }
        var lPointText = this.refs.usage_points_in_Select_input.options[selectedOption].value;
        var SCheduleText = "";
        if(this.state.UsageFamilyTypeId === '7')
            SCheduleText = this.state.FamilyText + ', ' + lPointText + ', Interval: ' + this.state.LimitValue + ' ' + this.refs.usage_points_in_Select_input.options[selectedOption].getAttribute('unitname');
        else
            SCheduleText = this.state.FamilyText + ', ' + this.state.EquipmentText + ', ' + lPointText + ', Interval: ' + this.state.LimitValue + ' ' + this.refs.usage_points_in_Select_input.options[selectedOption].getAttribute('unitname');
        this.setState({ UsagePointId : selectedPointId, PointDetails: lPointDts, UnitName: this.refs.usage_points_in_Select_input.options[selectedOption].getAttribute('unitname'),
            SchduleTypeText: SCheduleText, PointText: lPointText });
    }

    OnLimitChange(evt) {
        var SCheduleText = "";
        if(this.state.UsageFamilyTypeId === '7')
            SCheduleText =  this.state.FamilyText + ', ' + this.state.PointText + ', Interval: ' + evt.target.value + ' ' + this.state.UnitName;
        else
            SCheduleText =  this.state.FamilyText + ', ' + this.state.EquipmentText + ', ' + this.state.PointText + ', Interval: ' + evt.target.value + ' ' + this.state.UnitName;
        this.setState({ SchduleTypeText: SCheduleText, LimitValue: evt.target.value });
    }

    FormCustomFields(PMCustomFields){
        const l_rows = [];
        var Default_drop_down_value = <option value="" id="0" selected>{this.props.getLabels['WorkOrders.DropDown.Default.Text']}</option>
        if(this.props.getCustomFields !== undefined && this.props.getCustomFields !== null && this.props.getCustomFields.length){
            var lCustomFields = this.props.getCustomFields.filter(el => el.display === true);
            if(lCustomFields !== undefined && lCustomFields !== null && lCustomFields.length){
                var l_CustomFields = this.OnSort(lCustomFields);
                const l_lstCustomFields = l_CustomFields.map((item, index) => {
                    var SelectedValues = PMCustomFields.filter(el => el.customFieldId === item.fieldId);
                    var l_Value = "";
                    if(SelectedValues[0] !== undefined && SelectedValues[0] !== null){
                        l_Value = (item.fieldType === 0) ? SelectedValues[0].customFieldTextValue : SelectedValues[0].customFieldValueId;
                    }
                    if(item.fieldType === 0){
                        return <div className={index % 2 == 0 ? "grid-first-col customfieldsColtxt" : "grid-second-col customfieldsColtxt"} key={item.fieldId}>
                                <Label className="workorderlbl CreatePMlbl_margin">{(item.required) ? item.fieldLabel + "*" : item.fieldLabel}</Label>
                                <br />
                                <input type="text" maxLength={50} data-key={item.fieldId + '~' + item.required} defaultValue={l_Value} style={{width: '300px'}} className="pm_textbox customtxtbox" />
                                <span hidden={true}><Icon name='exclamation triangle' style={ErrorSign} /><br/>
                                <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>An entry is required</b></Label></span>
                            </div>
                    }else{
                        var customValue_in_Select_input;
                        if(item.value !== undefined && item.value !== null && item.value.length){
                            var custom_values = this.OnSort(item.value);
                            customValue_in_Select_input = custom_values.map(el => (
                                <option id={el.key} selected={el.key == l_Value}>{el.value}</option>
                            ));
                        }
                        return <div className={index % 2 == 0 ? "grid-first-col customfieldsColddl" : "grid-second-col customfieldsColddl"} key={item.fieldId}>
                                    <Label className="workorderlbl CreatePMlbl_margin">{(item.required) ? item.fieldLabel + "*" : item.fieldLabel}</Label><br />
                                    <select data-key={item.fieldId + '~' + item.required} id={"ddl_"+item.fieldId} className="minimal workorderedit-dropdown grid-ddl" style={{width: '300px'}}>
                                        {Default_drop_down_value}
                                        {customValue_in_Select_input}
                                    </select>
                                    <span hidden={true}><br/><Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>Please make a selection</b></Label></span>
                                </div>
                        }   
                });
                // Push a new row for every set of three fields
                for (let row = 0; row < Math.ceil(l_CustomFields.length / 2); row++) {
                    l_rows.push(<div key={"div_"+row} className="grid-padding-bottom" style={{"display":"inline-block"}}>
                        {l_lstCustomFields.slice((row * 2), ((row + 1) * 2))}
                    </div>);
                };
            }
        }
        return l_rows;
    }

    render(getWorkorderPreferences) {
        let IsEquipment = this.props.ForEquipment !== undefined && this.props.ForEquipment !== null ? this.props.ForEquipment : false;
        let label = this.props.getLabels;
        let PMPreferences = this.props.getPreferences;
        var errormsg;
        let error_record = null;
        let HasMailSetting = this.props.getMailSetting;
        if (this.state.redirectHome && !IsEquipment) {
            return <Redirect to={"/ManagePreventativeMaintenance"} />
        }
        else if(this.state.redirectHome && IsEquipment){
            return <Redirect to ={"/EquipmentWrapper"}/>
        }

        if(this.state.error.estimate){
            var x = document.getElementsByClassName("rc-time-picker-input");
            if(x.length > 0)
                x[0].className="rc-time-picker-error";
        }
        else
        {
            var x = document.getElementsByClassName("rc-time-picker-error");
            if(x.length > 0)
                x[0].className="rc-time-picker-input";  
        }

        var selecterrortext = <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>Please make a selection</b></Label>

        if (this.state.IsError) {
            errormsg = <p style={ErrorPadding} >
                <Icon name='exclamation triangle' style={ErrorSign} />
                <b>Please correct all errors before continuing.</b>
            </p>
        }

        var Status = '', AssignedTo = '', Name = '', Building = '', Equipment = '', Schedule = '', Description = '', EstimateTime = '', PartsAndTools = '', TaskList = '', FamilyType = '',NotifyOthers = '';

        if (PMPreferences != undefined && PMPreferences != '') {
            Status = PMPreferences.filter(x => x.field === "Status")[0];
            AssignedTo = PMPreferences.filter(x => x.field === "Assigned To")[0];
            Name = PMPreferences.filter(x => x.field === "Name")[0];
            Building = PMPreferences.filter(x => x.field === "Building")[0];
            Equipment = PMPreferences.filter(x => x.field === "Equipment")[0];
            Schedule = PMPreferences.filter(x => x.field === "Schedule")[0];
            Description = PMPreferences.filter(x => x.field === "Description")[0];
            EstimateTime = PMPreferences.filter(x => x.field === "Estimated Time")[0];
            PartsAndTools = PMPreferences.filter(x => x.field === "Parts & Tools")[0];
            TaskList = PMPreferences.filter(x => x.field === "Task List")[0];
            FamilyType = PMPreferences.filter(x => x.field === "Family Type")[0];
            NotifyOthers = PMPreferences.filter(x => x.field === "Notify Others")[0];
        }

        var Default_drop_down_value = <option value="" id="0" selected>{label['PreventativeMaintenance.DropDown.Default.Text']}</option>
        var status_in_Select_input = null, technicians_in_Select_input = null, interval_in_Select_input = null, notifiers_in_Select_input = [];
        var usage_buildings_in_Select_input = null, usage_familytype_in_Select_input = null, usage_equipment_in_Select_input = null, usage_point_in_Select_input = null;
        var Attachment_Table;
        var HasUsageSelected = this.state.ScheduleTypeRdl === 2 ? true : false;

        var status = label['PreventativeMaintenance.Status.Text'].split(',');
        if (Status.display) {
            if (Status.value.length > 0) {
                var status_values = this.OnSort(Status.value);
                status_in_Select_input = status_values.map(el => (
                    <option id={el.key} selected={el.key == this.state.StatusId}>{el.value}</option>
                ));
            }
            else {
                status_in_Select_input = status.map(el => (
                    <option id={el} value={el} selected={el == this.state.StatusId} >{label['PreventativeMaintenance.Status.' + el + '.Text']}</option>
                ));
            }
        }
        
        var Interval = label['CreatePM.Interval.Text'].split(',');
        if(Interval.length > 0){
            interval_in_Select_input = Interval.map(el => (
                <option id={el} value={el} selected={el == this.state.RepeatInterval}>{label['CreatePM.Interval.' + el + '.Text']}</option>
            ));
        }

        if (this.props.getTechnicianList != undefined && this.props.getTechnicianList != null) {
            let lSortedTechnicianlst = this.props.getTechnicianList.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) - (a.name.toLowerCase() < b.name.toLowerCase()));
            technicians_in_Select_input = lSortedTechnicianlst.map(el => (
                <option id={el.technicianID} selected={el.technicianID == this.state.UserID}>{el.name}</option>
            ));
            lSortedTechnicianlst.forEach(el => {
                if(el.technicianID !== Number(this.state.UserID) && el.emailAddress !== ""){
                    notifiers_in_Select_input.push({ "id": el.technicianID, "value" : el.name })
                }
            });
        }

        var BuildingsList = [];
        if (this.props.getWorkOrderBuildings != null && this.props.getWorkOrderBuildings != undefined && this.props.getWorkOrderBuildings.length > 0)
            BuildingsList = this.props.getWorkOrderBuildings.filter(el => el.isDeleted == false && el.siteId !== 0).sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()));
        if (BuildingsList != null && BuildingsList != undefined && BuildingsList.length > 0) {
            usage_buildings_in_Select_input = BuildingsList.map(el => (
                <option id={el.id} selected={this.state.UsageBuildingId == el.id}>{el.name}</option>
            ));
        }

        if (this.state.UsageFamilyTypes !== undefined && this.state.UsageFamilyTypes !== null && this.state.UsageFamilyTypes.length){
            usage_familytype_in_Select_input = this.state.UsageFamilyTypes.map(el => (
                <option id={el.familyId} selected={this.state.UsageFamilyTypeId == el.familyId}>{el.familyName}</option>
            ));
        }else{
            usage_familytype_in_Select_input = null;
        }

        if (this.state.UsageEquipments !== undefined && this.state.UsageEquipments !== null && this.state.UsageEquipments.length){
            usage_equipment_in_Select_input = this.state.UsageEquipments.map(el => (
                <option id={el.objectId} selected={this.state.UsageEquipmentId == el.objectId}>{el.objectName}</option>
            ));
        }else{
            usage_equipment_in_Select_input = null;
        }
        
        if (this.state.UsageBuildingPoints !== undefined && this.state.UsageBuildingPoints !== null && this.state.UsageBuildingPoints.length){
            var BcuBuildings = this.state.UsageBuildingPoints.filter(el => el.propertyId === 85);
            if(BcuBuildings.length > 0){
                usage_point_in_Select_input = this.state.UsageBuildingPoints.map(el => (
                    <option id={el.objectId} ObjectId={el.objectId} PropertyId={el.propertyId} ArrayIndex={el.arrayIndex} Dimension={el.dimension} UnitId={el.unitId} UnitName={el.unitName} selected={this.state.UsagePointId == el.objectId}>{el.name}</option>
                ));
            }else{
                usage_point_in_Select_input = this.state.UsageBuildingPoints.map(el => (
                    <option id={el.propertyId} ObjectId={el.objectId} PropertyId={el.propertyId} ArrayIndex={el.arrayIndex} Dimension={el.dimension} UnitId={el.unitId} UnitName={el.unitName} selected={this.state.PointDetails.propertyId == el.propertyId && this.state.PointDetails.arrayIndex == el.arrayIndex}>{el.name}</option>
                ));
            }
        }else{
            usage_point_in_Select_input = null;
        }

        error_record = <tr>
                        <td width="100%"><Icon name='exclamation triangle'style={{marginRight:'1px',padding:'0px',color:'#D42D27'}}/>{" An error has occurred. "}{this.state.errorImageName}{this.state.errorImageText}</td><td></td>
                      </tr>

        let PMDetails = this.props.getDetails.PreventativeMaintenanceDetail;
        if (PMDetails !== undefined && PMDetails !== null && PMDetails.attachments != null && PMDetails.attachments.length > 0) {
            Attachment_Table = PMDetails.attachments.map(el => (
                <tr>
                    <td className="link_cursorUnderline" style={{"width" : "90%", "word-wrap" : "break-word"}} onClick={() => {this.AttachmentDownload(el.fileName)}}>{el.name}</td>           
                    <td width="10%"><img src={DeleteIcon} className="Ensemble_Icon link_cursor" style={{ valign: 'bottom', "width" : "15px", "height" : "14px"}} onClick={() =>{this.DeleteAttachment(el.id,el.fileName)}} /></td>
                </tr>
            ));
        }
        else{
            Attachment_Table = <tr><td className="workorderlbl-noentry">{"No attachments"}</td><td>{" "}</td></tr>
        }

        //Applying Custom Fields
        let lstCustomFields= this.FormCustomFields(this.state.PMCustomFields);

        return (
            <div className= {this.props.Premise ? "main_container" : "cloud_main_container"} style={{"width" : "675px", "padding-top": "0px"}}>
                
                {this.state.IsError ? <div className="grid-padding-bottom">
                    {errormsg}
                </div> : ""
                }
                <div className="grid-padding-bottom">
                    <Label className="Pm_Redirect_Header" style={{"text-decoration": "underline", "cursor" : "pointer", "margin-bottom" : "0px"}} onClick={() => { this.togglePMList() }}>{label['PreventativeMaintenance.TitleHeader.Text']}</Label>
                    <Label className="Pm_Redirect_Header" style={{"margin-bottom" : "0px"}}>&nbsp;{" > "}{this.state.PMSerialNumber}</Label>
                </div>
                <div className="grid-padding-bottom" style={{'width':'620px'}}>
                    <Label className="Pm_Redirect_Header">{this.state.PMSerialNumber}</Label>
                    <div className="workorderbtn-cancel" id="btn_PM_Cancel" onClick={this.onCancel} style={{'float': 'right', 'margin-left': '6px'}}>CANCEL</div>
                    <div className="workorderbtn-save" id="btn_PM_Save" onClick={this.onPMUpdate} style={{'float': 'right'}}><MdSave style={{width: '15px', height: '15px', 'margin-right': '3px'}} />SAVE</div>
                </div>

                {   Name.display ? <div className="grid-padding-bottom">
                    <Label className={(this.state.error.name) ? "errortext grid-header-lbl CreatePMlbl_margin" : "grid-header-lbl CreatePMlbl_margin"}>{(Name.required) ? Name.fieldLabel + "*" : Name.fieldLabel}</Label>
                    <br />
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <input type="text" maxLength="50" ref='name_in_input' id="input_PM_Name" value={this.state.PMName} style={{ "width": "620px" }} className={(this.state.error.name) ? "errorhighlight pm_textbox" : "pm_textbox"} onChange={evt => this.UpdatePMName(evt)} />
                                        {this.state.error.name ? <Icon name='exclamation triangle' style={ErrorSign} /> : null}
                                    </div>
                                    <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato', 'margin-bottom': '-1px' }} hidden={!this.state.error.name}><b>Name can only contain letters, numbers, and the following characters _-.,&()$:!</b></Label>
                                </div> : null
                }

                {   (AssignedTo.display || Status.display) ? <div className="grid-padding-bottom">
                    { Status.display ? <div className="grid-first-col" style={{"padding-bottom":"16px"}}>
                            <Label className={(this.state.error.status) ? "errortext grid-header-lbl CreatePMlbl_margin" :"grid-header-lbl CreatePMlbl_margin"}>{(Status.required) ? Status.fieldLabel + "*" : Status.fieldLabel}</Label><br />
                            <select ref='status_in_Select_input' id="input_PM_Status" className={(this.state.error.status) ? "errorhighlight minimal workorderedit-dropdown grid-ddl" :"minimal workorderedit-dropdown grid-ddl"} style={{ width: '300px', "color": "gray" }} placeholder={label['PreventativeMaintenance.DropDown.Default.Text']} onChange={this.OnStatusChange} >
                                {Default_drop_down_value}
                                {status_in_Select_input}
                            </select>
                            <span hidden={!this.state.error.status}><br/>{selecterrortext}</span>
                    </div> : "" }
                    { (AssignedTo.display > 0) ?
                        <div className="grid-second-col">
                            <Label className={(this.state.error.assigneddto) ? "errortext grid-header-lbl CreatePMlbl_margin" : "grid-header-lbl CreatePMlbl_margin"}>{(AssignedTo.required) ? AssignedTo.fieldLabel + "*" : AssignedTo.fieldLabel}</Label><br />
                            <select ref='user_in_Select_input' id="input_PM_AssignedTo" className={(this.state.error.assigneddto) ? "errorhighlight minimal workorderedit-dropdown grid-ddl" : "minimal workorderedit-dropdown grid-ddl"} style={{ width: '300px', "color": "gray" }} placeholder={label['PreventativeMaintenance.DropDown.Default.Text']} onChange={this.OnUserChange} >
                                {Default_drop_down_value}
                                {technicians_in_Select_input}
                            </select>
                            <span hidden={!this.state.error.assigneddto}><br/>{selecterrortext}</span>
                            {(AssignedTo.display) ? <p style={{ 'margin-top': !this.state.error.assigneddto ? '-5px' : '-21px' }} ><br/>
                                <input type="checkbox" style={{'vertical-align':'middle', 'float': 'left'}} id="assigned_box" disabled={!HasMailSetting || !this.state.HasEmailAddress} checked={this.state.IsEmailChecked && HasMailSetting && this.state.HasEmailAddress} ref="ref_Assigned_User" onChange={this.emailChecked} /> <div className="grid-notify-aesignee"> Notify Assignee</div>
                            </p> : "" }
                    </div> : "" }
                </div> : ""}
                
                { (NotifyOthers.display > 0) ?
                <div className="grid-padding-bottom">
                    <div className="grid-first-col" style={{"width":"620px", "padding-bottom":"16px"}}>
                        <Label className={(this.state.error.notifyOthers) ? "errortext grid-header-lbl CreatePMlbl_margin" : "grid-header-lbl CreatePMlbl_margin"}>{(NotifyOthers.required) ? NotifyOthers.fieldLabel + "*" : NotifyOthers.fieldLabel}</Label><br />
                        <MultiSelectComponent id="select_pmnotifyothers" ref='pmnotifyothers_in_Select_input' width='300px' cssClass={(this.state.error.notifyOthers) ? classnames("arrowdown-error multiselect-dropdown", "arrowdown multiselect-dropdown") : "arrowdown multiselect-dropdown multiselect-grid-ddl"} style={{"color": "gray"}}
                            dataSource={notifiers_in_Select_input}
                            fields={this.dropdown_fields}
                            mode="CheckBox"
                            select={this.onNotifyOthersSelect.bind(this)}
                            removed={this.onNotifyOthersRemove.bind(this)}
                            value={this.state.SelectedNotifyOthersIds}
                            showSelectAll={true} enableSelectionOrder={false}
                            filterBarPlaceholder="Search" placeholder="Select" selectAllText="Select All" unSelectAllText="Clear All" >
                            <Inject services={[CheckBoxSelection]} />
                        </MultiSelectComponent>
                        { this.state.error.notifyOthers ? <br/> : ""}
                                    <span hidden={!this.state.error.notifyOthers}>{selecterrortext}</span>
                    </div>
                </div>:""}

                <div className="grid-padding-bottom">
                    <div className="grid-first-col" style={{"width":"620px", "padding-bottom":"16px"}}>
                        <Label className="grid-header-lbl CreatePMlbl_margin">{label['CreatePM.Due.Text']}</Label><br />
                            {
                                HasUsageSelected ? this.state.UsageRemaining === null ? <Label className="workorderlbl grid-no-margin-bottom">NO DATA AVAILABLE</Label> : this.state.UsageRemaining === 0 ? <Label className="workorderlbl CreatePMlbl_margin grid-no-margin-bottom">{this.state.PMDueDate}</Label> :
                                <div style={{"margin-top":"-5px", 'width':'300px'}}><span className="progressbar-label">{this.state.UsageRemaining + "% usage remaining"}</span><br/><ProgressBar className="progressbar-border" now={100-this.state.UsageRemaining} /></div>
                                :
                                <label id="pm_due_wrapper" style={{'cursor':'pointer', "width": "300px", "margin-bottom" : "0px"}}>
                                    <DatePicker id="dp_Due_date" selected={this.state.DueDate} minDate={(this.state.PMBuilding != "---") ? this.state.SelectedBuildingDate : this.state.ServerDate} onChange={this.handleChange} className="workorderedit-dropdown pm_bg_color Pm_Full_Width" />
                                    <div className="pm_calendardiv">
                                        <FaRegCalendarAlt className="pm_calendarbox" />
                                    </div>
                                </label>
                            }
                    </div>
                </div>
            
                {/* Hr Line */}
                <div className="grid-padding-bottom">
                    <div className="grid-first-col" style={{"width":"620px"}}>
                        <hr style={{ backgroundColor: '#666666', border: 'none', height: '1px' }} />
                    </div>
                </div>

                {/*Details Header Row*/}
                <div className="grid-padding-bottom"> 
                    <div className="grid-first-col" style={{"width":"620px", "padding-bottom": "7px"}}>
                        <Label className='grid-type-lbl' style={{"margin-bottom":"0px"}}>{label['PreventativeMaintenance.Details.Text'] !== undefined ? label['PreventativeMaintenance.Details.Text'] : "Details"}</Label>
                    </div>
                </div>

                {   Building != undefined && Building.display ?           
                <div className="grid-padding-bottom">
                    <div className="grid-first-col" style={{"width":"620px", "padding-bottom":"16px"}}>
                        <Label className="grid-header-lbl CreatePMlbl_margin">{(Building.required) ? Building.fieldLabel + "*" : Building.fieldLabel}</Label><br />
                        <Label className="workorderheaderlbl CreatePMlbl_margin">{this.state.PMBuilding}</Label>
                    </div>
                </div> : "" }

                {   (FamilyType != undefined && FamilyType.display) || Equipment.display ? <div className="grid-padding-bottom">
                    { FamilyType != undefined && FamilyType.display ? <div className="grid-first-col" style={{"width":"300px", "padding-bottom":"16px"}}>
                        <Label className="grid-header-lbl CreatePMlbl_margin">{(FamilyType.required) ? FamilyType.fieldLabel + "*" : FamilyType.fieldLabel}</Label><br />
                        <Label className="workorderheaderlbl CreatePMlbl_margin">{this.state.PMFamilyType}</Label>
                        </div> : ""
                    }
                    {   Equipment.display ? <div className="grid-second-col" style={{"width":"300px", "padding-bottom":"16px"}}>
                        <Label className="grid-header-lbl CreatePMlbl_margin">{(Equipment.required) ? Equipment.fieldLabel + "*" : Equipment.fieldLabel}</Label><br />
                        <Label className="workorderheaderlbl CreatePMlbl_margin">{this.state.PMEquipment}</Label>
                        </div> : "" 
                    }
                </div> : "" }

                { Schedule.display ?
                <div className="grid-padding-bottom">
                    <div className="grid-first-col" style={{"width":"620px", "padding-bottom":"16px"}}>
                    <Label className={(this.state.error.schedule) ? "errortext grid-header-lbl CreatePMlbl_margin" : "grid-header-lbl CreatePMlbl_margin"}>{(Schedule.required) ? Schedule.fieldLabel + "*" : Schedule.fieldLabel}</Label><br />
                    <Label className={this.state.error.schedule ? "errortext workorderheaderlbl CreatePMlbl_margin" : "workorderheaderlbl CreatePMlbl_margin"}>{this.state.SchduleTypeText}
                        <Edit className="Ensemble_Building_Icon pm_Shedule_Edit" onClick={this.Scheduletoggle} />
                    </Label>
                    </div>
                </div> : ""
                }

                {lstCustomFields}

                { EstimateTime.display ?
                <div className="grid-padding-bottom">
                    <div className="grid-first-col" style={{"width":"620px", "padding-bottom":"16px"}}>
                        <Label className={(this.state.error.estimate) ? "errortext grid-header-lbl CreatePMlbl_margin" : "grid-header-lbl CreatePMlbl_margin"}>{(EstimateTime.required) ? EstimateTime.fieldLabel + "*" : EstimateTime.fieldLabel}</Label>
                        <br/>
                        <label style={{'cursor':'pointer'}}>
                                <TimePicker ref="Time_in_timepicker" id="input_PM_EstimateTime" onChange={this.handleValueChange} value={this.state.EstimatedTime} showSecond={false} open={this.state.open} onOpen={this.setOpen} onClose={this.setClose} style={{ width: '100%' }} focusOnOpen className={(this.state.error.estimate) ? "errorhighlight" : ""} />
                                <div className="pm_timerdiv">
                                    <FaClock className="pm_calendarbox" width="17px" height="17px" />
                                </div>
                        </label>
                    </div>
                </div> : ""
                }

                { Description.display ?
                <div className="grid-padding-bottom">
                    <div className={(this.state.error.description) ? this.props.ForEquipment ? "grid-first-col-equip-error grid-first-col" : "grid-first-col-error grid-first-col" : "grid-first-col"} style={{"padding-bottom":"16px"}}>
                            <Label className={(this.state.error.description) ? "errortext grid-header-lbl CreatePMlbl_margin" : "grid-header-lbl CreatePMlbl_margin"}>{(Description.required) ? Description.fieldLabel + "*" : Description.fieldLabel}</Label><br />
                            <textarea ref='description_in_textarea' id="input_PM_Description" style={{ width: '620px' }} className={(this.state.error.description) ? "errorhighlight workorderedit-textarea workorderheaderlbl" : "workorderedit-textarea workorderheaderlbl"} value={this.state.Description} onChange={evt => this.updateDescriptionValue(evt)} />
                            <span hidden={!this.state.error.description} style={{ position: 'relative', top: this.props.ForEquipment ? '3px' : '-5px' }}><Icon name='exclamation triangle' style={ErrorSign} /><br/>
                                        <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>An entry is required</b></Label></span>
                    </div>
                </div> : ""
                }

                { PartsAndTools.display ?
                <div className="grid-padding-bottom">
                    <div className={(this.state.error.parts) ? this.props.ForEquipment ? "grid-first-col-equip-error grid-first-col" : "grid-first-col-error grid-first-col" : "grid-first-col"} style={{"padding-bottom":"16px"}}>
                            <Label className={(this.state.error.parts) ? "errortext grid-header-lbl CreatePMlbl_margin" : "grid-header-lbl CreatePMlbl_margin"}>{(PartsAndTools.required) ? PartsAndTools.fieldLabel + "*" : PartsAndTools.fieldLabel}</Label><br />
                            <textarea ref='parts_in_input' id="input_PM_PartsTools" style={{ width: '620px' }} className={(this.state.error.parts) ? "errorhighlight pm_box" :"pm_box"} value={this.state.PartsTools} onChange={evt => this.updatePartsTools(evt)} />
                            <span hidden={!this.state.error.parts} style={{ position: 'relative', top: this.props.ForEquipment ? '3px' : '-5px' }}><Icon name='exclamation triangle' style={ErrorSign} /><br/>
                                        <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato' }}><b>An entry is required</b></Label></span>
                    </div>
                </div> : ""
                }

                { TaskList.display ?
                <div className="grid-padding-bottom">
                    <div className={(this.state.error.tasklist) ? this.props.ForEquipment ? "grid-first-col-equip-error grid-first-col" : "grid-first-col-error grid-first-col" : "grid-first-col"} style={{"padding-bottom":"16px"}}>
                        <Label className={(this.state.error.tasklist) ? "errortext grid-header-lbl CreatePMlbl_margin":"grid-header-lbl CreatePMlbl_margin"}>{(TaskList.required) ? TaskList.fieldLabel + "*" : TaskList.fieldLabel}</Label><br />
                        <div  style={(this.state.error.tasklist) ? {width:'620px',marginBottom:'-17px',padding:'2px'} :{ width: '620px',padding:'2px' }} className={(this.state.error.tasklist) ? "errorhighlight pm_tasklist": "pm_tasklist"} ref="tasklist" id="tasklist">
                            <table style={{width:'100%'}}>
                                <tbody id="taskid">
                                {(this.state.Tasks !== null && this.state.Tasks.length !== 0) ? this.state.Tasks.map((el,index) =>(
                                     <tr>
                                        <td className="col-sm-12" style={{padding:'0px'}}>
                                            <span contentEditable="false"><input type="checkbox" defaultChecked = {el.isChecked}  id={"check"+ index}  style={{'vertical-align':'middle'}}/></span>&nbsp;
                                            <input type="text" style={
                                                {border:'none',backgroundColor:'rgb(244,244,244)','vertical-align':'middle',width:'90%'}} onKeyUp={this.keyPressed} contentEditable="true" defaultValue={el.Description} id={"task"+ index}></input>
                                        </td>
                                </tr> )) :
                                    <tr>
                                        <td className="col-sm-12" style={{padding:'0px'}}>
                                        <span contenteditable="false"><input type="checkbox" id="check0"  style={{'vertical-align':'middle'}}/></span>&nbsp;
                                        <input type="text" id="task0" ref="tasklist_input" style={
                                                {border:'none',backgroundColor:'rgb(244,244,244)','vertical-align':'middle',width:'90%'}} onKeyUp={this.keyPressed} contenteditable="true"/>
                                        </td>
                                    </tr> 
                                }
                                </tbody>
                            </table>
                            </div>
                            <span hidden={!this.state.error.tasklist} style={{ position: 'relative', top: this.props.ForEquipment ? '-22px' : '-5px' }}><Icon name='exclamation triangle' style={{color: '#D42D27',paddingTop: '4px',paddingRight: '14px',width: '22px',height: '22px',top: '406px',left: '959px',float:'right', paddingLeft: '7px'}} /><br/>
                                        <Label style={{ 'color': '#D42D27', 'font-style': 'italic', 'font-size': '10px', 'font-family': 'Lato', 'margin-bottom': '-5px', 'padding-top': this.props.ForEquipment ? '22px' :'8px' }}><b>An entry is required</b></Label></span>
                    </div>
                </div> : ""
                }

                <div className="grid-padding-bottom">
                    <div className="grid-single-col">
                        <Label className="grid-header-lbl" style={{'padding-top':'5px'}}>{label['WorkOrders.Heading.Attachments.Text']}</Label>
                        <Label className="workorderedit-choosebtn" style={{float:'right', 'margin-top': '5px'}}>
                            <input type="file"  id="myfile" onChange={(e) => {this.AddAttachment(e); e.target.value=null}} />{label['WorkOrderEdit.ChooseFile.Text']}
                        </Label>
                        <br/>
                        <Table responsive className="attachmentTable" id="tbl_PM_Attachments">
                            <tbody>
                                <tr><th width="90%">ATTACHMENTS</th><th width="10%">{" "}</th></tr>
                                {Attachment_Table}  
                                {(this.state.displayImageError) ? error_record : null }
                            </tbody>
                        </Table>
                        <Label className="workorderlbl-noentry">{label['WorkOrderEdit.FileTypes.Text']}</Label>
                    </div>
                </div>
                
                <Modal isOpen={this.state.Schedulemodal} id="PM_Recurence_Modal" className={classnames({ classnames: this.props.className }, "ModalContainer short_modal")} >
                    <div style={{"margin-left":"10px", "margin-bottom":"-13px"}}>
                        <Label className='workordermainheaderlbl' style={{ paddingTop:'8px' }}>{label['CreatePM.MaintenanceSchedule.Text'] !== undefined ? label['CreatePM.MaintenanceSchedule.Text'] : "Maintenance Schedule"}</Label>
                        <div style={{ valign: 'bottom', 'float':'right', padding:'8px' }} className="PM_Close_Icon" onClick={this.Scheduletoggle}><IoMdClose/></div>
                    </div>
                    <Form style={{'overflow':'visible'}}>
                        <FormGroup row style={{ "margin-bottom": "1px", "margin-right":"0px", "margin-left":"0px" }}>
                            <Col sm={{ size: 12 }} style={{ "padding-left":"0px", "padding-right":"0px" }}>
                                <hr style={{backgroundColor:'1px solid #CCCCCC' }}/>
                            </Col>
                        </FormGroup>
                        <div className="Recurrendiv_Content">
                            <FormGroup row style={{'margin-top':'17px'}}>
                                <Col sm={{ size: 12 }} style={{'margin-left':'15px'}}>
                                    <Label className='Recurrendiv_Label'>{label['CreatePM.Recurrence.Text'] !== undefined ? label['CreatePM.Recurrence.Text'] : "Recurrence*"}</Label>
                                    <br/>
                                    <Label className="Recurrendiv_Label"><input id="am_rdl_usage" type="radio" defaultChecked={HasUsageSelected} ref="rdl_Usage" name="ScheduleType" className="pm_regular_radiobtn" onChange={this.ScheduleTypeChange} />&nbsp;{label['CreatePM.Usage.Text'] !== undefined ? label['CreatePM.Usage.Text'] : "Based on usage"}</Label>
                                    <Label className="Recurrendiv_Label" style={{'margin-left':'10px'}}><input id="am_rdl_calendar" type="radio" defaultChecked={!HasUsageSelected} ref="rdl_Calendar" name="ScheduleType" className="pm_regular_radiobtn" onChange={this.ScheduleTypeChange} />&nbsp;{label['CreatePM.Calendar.Text'] !== undefined ? label['CreatePM.Calendar.Text'] : "Based on calendar"}</Label>
                                </Col>
                            </FormGroup>
                            <div style={{"display":(this.state.ScheduleTypeRdl === 1 || this.state.ScheduleTypeRdl === 0) ? "block":"none"}}>
                                <FormGroup row style={{"display":this.state.IsCalendarDisplay}}>
                                    <Col sm={{ size: 6 }} style={{ 'margin-left': '15px' }}>
                                        <Label className='Recurrendiv_Label' style={{ 'margin-bottom': '0px' }}>{label['CreatePM.DueDate.Text'] !== undefined ? label['CreatePM.DueDate.Text'] : "Due Date*"}</Label>
                                        <br />
                                        <label style={{ 'cursor': 'pointer' }}>
                                            <DatePicker id="dp_Schedule_Due_date" selected={this.state.RecurrenceDueDate} minDate={this.state.PMBuilding != "---" ? this.state.SelectedBuildingDate : this.state.ServerDate} onChange={this.handleScheduleDueChange} className={(this.state.DueDateError) ? "workorderedit-dropdown pm_bg_color Pm_Full_Width errorhighlight" : "workorderedit-dropdown pm_bg_color Pm_Full_Width"} />
                                            <div className="pm_calendardiv">
                                                <FaRegCalendarAlt className="pm_calendarbox" />
                                            </div>
                                        </label>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm={{ size: 12 }} style={{ 'margin-left': '15px' }}>
                                        <Label className='Recurrendiv_Label' style={{ 'margin-bottom': '0px' }}>{label['CreatePM.RepeatEvery.Text'] !== undefined ? label['CreatePM.RepeatEvery.Text'] : "Repeat every*"}</Label>
                                        <br />
                                        <input type="text" id="am_txtmodifier" ref='modifier_in_input' defaultValue={this.state.RepeatEvery} style={{ width: '30%' }} className={(this.state.RepeatEveryError) ? "pm_textbox errorhighlight" : "pm_textbox"} onChange={evt => this.OnCalendarLimitChange(evt)} />
                                        <select id="am_ddl_interval" ref='interval_in_Select_input' className="minimal workorderedit-dropdown" style={{ width: '50%', "margin-left": "8px" }} onChange={this.OnIntervalChange} >
                                            {interval_in_Select_input}
                                        </select>
                                    </Col>
                                </FormGroup>
                            </div>
                            <div style={{"display":this.state.ScheduleTypeRdl === 2 ? "block":"none"}}>
                                <FormGroup row>
                                    <Col sm={{ size: 10}} style={{ 'margin-left': '15px' }}>
                                        <Label className={(this.state.UsageError.building) ? "errortext workorderlbl UsageCreatePMlbl_margin" :"workorderlbl UsageCreatePMlbl_margin"}>Building*</Label><br />
                                        <select id="am_ddl_usagebuilding" ref='usage_building_in_Select_input' className={(this.state.UsageError.building) ? "errorhighlight minimal workorderedit-dropdown" :"minimal workorderedit-dropdown"} style={{ width: '100%', "color": this.state.UsageBuildingId !== '0' ? '#000000' : '#999999' }} onChange={this.OnUsageBuildingChange} >
                                            {Default_drop_down_value}
                                            {usage_buildings_in_Select_input}
                                        </select>
                                        <span hidden={!this.state.UsageError.building}>{selecterrortext}</span>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm={{ size: 10}} style={{ 'margin-left': '15px' }}>
                                        <Label className={(this.state.UsageError.Family) ? "errortext workorderlbl UsageCreatePMlbl_margin" :"workorderlbl UsageCreatePMlbl_margin"}>Family Type*</Label><br />
                                        <select id="am_ddl_usagefamily" ref='usage_family_in_Select_input' className={(this.state.UsageError.Family) ? "errorhighlight minimal workorderedit-dropdown" :"minimal workorderedit-dropdown"} style={{ width: '100%', "color": this.state.UsageFamilyTypeId !== '0' ? '#000000' : '#999999' }} onChange={this.OnUsageFamilyTypeChange} >
                                            {Default_drop_down_value}
                                            {usage_familytype_in_Select_input}
                                        </select>
                                        <span hidden={!this.state.UsageError.Family}>{selecterrortext}</span>
                                    </Col>
                                </FormGroup>
                                <FormGroup row style={{"display" : this.state.UsageFamilyTypeId != '7' ? "block" : "none"}}>
                                    <Col sm={{ size: 10}} style={{ 'margin-left': '15px' }}>
                                        <Label className={(this.state.UsageError.Equipment) ? "errortext workorderlbl UsageCreatePMlbl_margin" :"workorderlbl UsageCreatePMlbl_margin"}>Equipment*</Label><br />
                                        <select id="am_ddl_usageequipment" ref='usage_equipment_in_Select_input'className={(this.state.UsageError.Equipment) ? "errorhighlight minimal workorderedit-dropdown" :"minimal workorderedit-dropdown"} style={{ width: '100%', "color": this.state.UsageEquipmentId !== '0' ? '#000000' : '#999999', "display" : this.state.UsageFamilyTypeId !== '7' ? "block" : "none" }} onChange={this.OnUsageEquipmentChange} >
                                            {Default_drop_down_value}
                                            {usage_equipment_in_Select_input}
                                        </select>
                                        <span hidden={!this.state.UsageError.Equipment}>{selecterrortext}</span>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm={{ size: 10}} style={{ 'margin-left': '15px' }}>
                                        <Label className={(this.state.UsageError.Point) ? "errortext workorderlbl UsageCreatePMlbl_margin" :"workorderlbl UsageCreatePMlbl_margin"}>Points*</Label><br />
                                        <select id="am_ddl_usagepoints" ref='usage_points_in_Select_input' className={(this.state.UsageError.Point) ? "errorhighlight minimal workorderedit-dropdown" :"minimal workorderedit-dropdown"} style={{ width: '100%', "color": this.state.UsagePointId !== '0' ? '#000000' : '#999999' }} onChange={this.OnUsagePointsChange} >
                                            {Default_drop_down_value}
                                            {usage_point_in_Select_input}
                                        </select>
                                        <span hidden={!this.state.UsageError.Point}>{selecterrortext}</span>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm={{ size: 10}} style={{ 'margin-left': '15px' }}>
                                        <Label className={(this.state.UsageError.limit) ? "errortext workorderlbl UsageCreatePMlbl_margin" :"workorderlbl UsageCreatePMlbl_margin"}>Interval*</Label><br />
                                        <input type="text" id="am_ddl_usageparameter" ref='usage_parameter_in_input' style={{ width: '70%' }} className= {(this.state.UsageError.limit) ? "errorhighlight pm_textbox" : "pm_textbox"} defaultValue={this.state.LimitValue} onChange={evt => this.OnLimitChange(evt)} />
                                        <Label className="workorderlbl CreatePMlbl_margin" style={{'padding-left':'10px'}}>{this.state.UnitName}</Label>
                                    </Col>
                                </FormGroup>
                            </div>
                            <FormGroup row>
                                <Col sm={{ size: 8}} style={{ 'margin-left': '15px' }}>
                                    <Label className="workorderlbl-noentry">{this.state.SchduleTypeText}</Label>
                                </Col>
                            </FormGroup>
                        </div>
                        <FormGroup row style={{ "margin-bottom": "0px", "margin-right":"0px", "margin-left":"0px" }}>
                            <Col sm={{ size: 12 }} style={{ "padding-left":"0px", "padding-right":"0px" }}>
                                <hr style={{backgroundColor:'1px solid #CCCCCC', "margin-bottom": "4px" }}/>
                                <Label className='Pm_RecurrenceRequiredText' style={{"margin-left":"10px"}}>{"* required fields"}</Label>
                            </Col>
                        </FormGroup>
                    </Form>
                    <div style={{"margin-right":"10px", "margin-bottom":"4px"}}>
                        <Button id="am_btn_schedulecancel" className="wo_cancel_btn" style={{ 'float': 'right', 'margin-left': '6px' }} onClick={this.OnCancelRecurrencePattern}>{label['PreventativeMaintenance.Button.Cancel.Text']}</Button>
                        <Button id="am_btn_schedulesave" className="wo_save_btn" style={{ 'float': 'right' }} onClick={this.OnSaveRecurrencePattern} disabled={this.state.IsClickSave} > {label['PreventativeMaintenance.Button.Save.Text']}</Button>
                    </div>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        getDetails: state.WorkorderRootReducer,
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getTechnicianList: state.WorkorderRootReducer.Technicians,
        getWorkOrderBuildings: state.WorkorderRootReducer.WorkorderBuildings,
        getPreferences: state.authService.preventative_maintenance_user_preferencedetails,
        getUsageFamilyTypes: state.WorkorderRootReducer.UsageBuildingFamilyTypes,
        getUsageEquipmentsByFamily: state.WorkorderRootReducer.UsageBuildingEquipmentsByFamilyType,
        getBuildingEquipmentPoints: state.WorkorderRootReducer.BuildingEquipmentPoints,
        getBuildingPoints: state.WorkorderRootReducer.BuildingPoints,
        EquipmentSummary: state.authService.EquipmentSummaryDetail,
        getCustomFields: state.WorkorderRootReducer.PreventativeMaintenanceCustomFields,
        getMailSetting: state.WorkorderRootReducer.MailSetting,
        getUniqueAttachmentName: state.WorkorderRootReducer.UniqueAttachmentName
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetPreventativeMaintenanceDetails: (PMId) => dispatch(GetPreventativeMaintenanceDetails(PMId)),
        SaveAttachmentToFolder: (file, AttachmentId) => dispatch(SaveAttachmentToFolder(file, AttachmentId)),
        DeleteAttachment: (lineitem) => dispatch(DeleteAttachment(lineitem)),
        GetWorkOrderBuildingsList: () => dispatch(GetWorkOrderBuildingsList()),
        GetWorkorderTechnician: () => dispatch(GetWorkorderTechnician()),
        UpdatePreventativeMaintenance: (data, id) => dispatch(UpdatePreventativeMaintenance(data, id)),
        UpdatePreventativeMaintenanceState: (data, id) => dispatch(UpdatePreventativeMaintenanceState(data, id)),
        DownloadAttachment: (data) => dispatch(DownloadAttachment(data)),
        AddPMAttachments: (data, id) => dispatch(AddPMAttachments(data, id)),
        DeletePMAttachment: (PMID,id) => dispatch(DeletePMAttachment(PMID,id)),
        GetUsageFamilyTypesBySiteId: (id) => dispatch(GetUsageFamilyTypesBySiteId(id)),
        GetUsageEquipmentsByFamilyType: (siteId, id) => dispatch(GetUsageEquipmentsByFamilyType(siteId, id)),
        GetBuildingPoints: (siteId) => dispatch(GetBuildingPoints(siteId)),
        GetBuildingEquipmentPoints: (siteId, equipId) => dispatch(GetBuildingEquipmentPoints(siteId, equipId))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UpadtePreventativeMaintenance)